export function isNullOrUndefined(value) {
  return value === null || value === undefined;
}

export function isNumber(value) {
  return typeof value === 'number';
}

export function isDate(value) {
  return value instanceof Date;
}

export function isBoolean(value) {
  return typeof value === 'boolean';
}

export function isString(value) {
  return typeof value === 'string';
}

export function isNull(value) {
  return value === null;
}

export function isArray(value) {
  return Array.isArray(value);
}
